import { Contract } from "../models/contract/Contract"
import { ContractUnilever } from "../models/contract/ContractUnilever"
import { Harvest } from "../models/contract/Harvest"
import { Person } from "../models/person/Person"
import { LandPlotDashBoardModel } from "../pages/dashboard/models/LandPlotDashBoardModel"

export const fruitQuantity = (contracts: ContractUnilever[]) => {
    return contracts.reduce((v, cc) => v + cc.getFruitQuantity(), 0)
}

export const fruitUnileverPlotQuantity = (contracts: ContractUnilever[]) => {
    return contracts.reduce((v, cc) => v + cc.getUnileverFruitQuantity(), 0)
}

export const fruitNonUnileverPlotQuantity = (contracts: ContractUnilever[]) => {
    return contracts.reduce((v, cc) => v + cc.getNonUnileverFruitQuantity(), 0)
}

export const totalUlLandPlot = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getUnileverLandPlotsId())).size
}

export const totaLandPlot = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getLandPlotsId())).size
}

export const totalNonUlLandPlot = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getNonUnileverLandPlotsId())).size
}

export const totalUnileverFarmers = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getUnileverFarmerPersonIds())).size
}


export const totalNonUnileverFarmers = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getNonUnileverFarmerPersonIds())).size
}

export const allFarmers = (contracts: ContractUnilever[]) => {
    return new Set(contracts.flatMap((c) => c.getFarmerPersonIds()))
}

export const allAgent = (contracts: ContractUnilever[]) => {
    return new Set(contracts.map((c) => c.agentTransactorId()))
}

export const allFarmersUndeclared = (contracts: ContractUnilever[]): Map<number, Person> => {
    const map = new Map()
    const farmers = contracts.flatMap((c) => c.getFarmersUndeclared())
    farmers.forEach(f => {
        if (f.id) {
            map.set(f.id, f)
        }
    })
    return map
}

export const allFarmersDeclaredUlLandplot = (contracts: ContractUnilever[]): Map<number, Person> => {
    const map = new Map()
    const farmers = contracts.flatMap((c) => c.getFarmersDeclaredUlLandplot())
    farmers.forEach(f => {
        if (f.id) {
            map.set(f.id, f)
        }
    })
    return map
}

export const allFarmersDeclaredNonUlLandplot = (contracts: ContractUnilever[]): Map<number, Person> => {
    const map = new Map()
    const farmers = contracts.flatMap((c) => c.getFarmersDeclaredNonUlLandplot())
    farmers.forEach(f => {
        if (f.id) {
            map.set(f.id, f)
        }
    })
    return map
}

// export function generatePlotInfo(contracts: ContractUnilever[]): LandPlotDashBoardModel[] {
//     const harvests = contracts.flatMap(c => {
//         return c.getHarvests()
//     })
//     const plotSorted: Map<number, LandPlotDashBoardModel> = new Map()
//     harvests.forEach(h => {
//         var plotAggregate = plotSorted.get(h.land_plot.id)
//         if (plotAggregate) {
//             plotAggregate.addInfo(h)
//         } else {
//             plotAggregate = new LandPlotDashBoardModel(h.land_plot)
//             plotAggregate.addInfo(h)
//         }
//         plotSorted.set(h.land_plot.id, plotAggregate)
//     })
//     return [...plotSorted.values()]
// }

export function generatePlotInfoContractList(contracts: Contract[]): LandPlotDashBoardModel[] {
    const harvests = contracts.flatMap(c => {
        return c.getHarvests()
    })
    const plotSorted: Map<number, LandPlotDashBoardModel> = new Map()
    harvests.filter(h => h).forEach(h => {
        var plotAggregate = plotSorted.get(h.land_plot.id)
        if (plotAggregate) {
            plotAggregate.addInfoExport(h)
        } else {
            plotAggregate = new LandPlotDashBoardModel(h.land_plot)
            plotAggregate.addInfoExport(h)
        }
        plotSorted.set(h.land_plot.id, plotAggregate)
    })
    return [...plotSorted.values()]
}

export const totalUnileverContracts = (contracts: ContractUnilever[]): number => {
    return contracts.filter(c => c.isUnileverContract()).length
}

export const totalAmount = (contracts: ContractUnilever[]) => {
    return contracts.map(c => c.getTotalNetRp()).reduce((v, c) => v + c, 0)
}

export const totalPpunch = (contracts: ContractUnilever[]): number => {
    return contracts.reduce((v, c) => v + c.getPpunch(), 0)
}

// export const getUnileverHarvests = (contracts: ContractUnilever[]): Harvest[] => {
//     return contracts.flatMap(c => c.getUnileverHarvest())
// }

// export const getHarvests = (contracts: ContractUnilever[]): Harvest[] => {
//     return contracts.flatMap(c => c.harvests.map(h => h.harvest))
// }

export const percentPpunchOnGMV = (contracts: ContractUnilever[]): number => {
    const totalNet = contracts.reduce((v, c) => v + c.getTotalNetRp(), 0)
    const totalPp = totalPpunch(contracts)
    if (totalPp > 0 && totalNet > 0) {
        return (totalPp / totalNet) * 100
    }
    return 0
}

export const fruitTracability = (contracts: ContractUnilever[]): number => {
    const nonUniQuantity = contracts.reduce((v, c) => v + (c.getNonUnileverFruitQuantity() ?? 0), 0)
    const uniQuantity = contracts.reduce((v, c) => v + (c.getUnileverFruitQuantity() ?? 0), 0)
    const total = nonUniQuantity + uniQuantity
    if (uniQuantity === 0) return undefined
    return uniQuantity / total
}